import React from 'react'
export default function Return() {
    return (
        <div className={`globalcenter pb-5`}>
            <h1 className='mb-5'>Shipping & Returns</h1>
            <hr />
            <h4>Shipping Policy</h4>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae optio, rem excepturi debitis deserunt quaerat porro est laboriosam laudantium velit dignissimos ea repudiandae exercitationem neque. Excepturi incidunt vitae aliquid pariatur.</p>
            <h4>Return & Exchange Policy</h4>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae optio, rem excepturi debitis deserunt quaerat porro est laboriosam laudantium velit dignissimos ea repudiandae exercitationem neque. Excepturi incidunt vitae aliquid pariatur.</p>
        </div>
    )
}
